<pdq-card variant="flat" color="white" [formGroup]="orderEditingService.form.get('template.addressValidation')">
  <div class="card-container">
    <div class="card-header">
      <div class="card-header__left">
        <pdq-heading element="h6">Address Validation</pdq-heading>
        <pdq-tag variant="success"
          >{{ orderEditingService.form.get('template.periods.value').value }}
          {{ orderEditingService.form.get('template.periods.type').value | titlecase }}</pdq-tag
        >
      </div>
      <pdq-slide-toggle formControlName="enabled" togglePosition="right"></pdq-slide-toggle>
    </div>

    <pdq-divider></pdq-divider>
    <div class="card-body">
      <div class="card-body__comment">
        <pdq-icon color="var(--on-surface-light)" icon="alarm"></pdq-icon>
        <p class="body-14-regular">
          Correction window follows the <pdq-link (onClick)="openSettings()" label="Settings"></pdq-link>tab edit time
          limit.
        </p>
      </div>
    </div>
  </div>
</pdq-card>
